import { filterPageTypes, toggleFilterTypes } from 'src/app/store/filters.era';
import { getFilteredSidebarTasks, getFilteredPageTasks, getFilteredMyTasks } from '../../store/reselectors/filteredTasks.reselector';
import { ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { animate } from '@angular/animations';
import { trigger, state, style, transition } from '@angular/animations';
import { Component, OnInit, Input } from '@angular/core';
import { Task, tasksActions, tasksFeature } from 'src/app/store/tasks.era'
import { WFWorker, JoiEvent, LabelObject } from 'src/app/store/events.era';
import { EventPreferenceDoc } from 'src/app/store/event.preferences.era'
import { ManageTaskComponent, ManageTaskData, ManageTaskReturnType } from 'src/app/modules/manage/manage-task.component';
import { openDialogGetResult, transformObservableToSinglePromise } from 'src/app/helpers/angular-helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import publicHelpers from 'src/app/helpers/public-helpers';
import { Subtask } from 'globals/store/tasks.data';
import { Wrapper } from '../wrapper.component';
import { IconComponent } from '../icon/icon.component';
import { CommonModule, DatePipe } from '@angular/common';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { TaskStatusDropdownComponent } from 'src/app/modules/tasks/task-status-dropdown.component';
import { PhotoComponent } from '../photo';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-task-list',
    animations: [
        trigger('squish', [
            state('relaxed, void', style({ height: '*' })),
            state('squished, null', style({ height: '0', padding: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    templateUrl: './task-list.component.html',
    styleUrls: ['./task-list.component.scss'],
    standalone: true,
    imports: [IconComponent, DatePipe, CommonModule, JoiInputComponent, TaskStatusDropdownComponent, PhotoComponent, MatFormFieldModule, FormsModule],
})
export class TaskListComponent extends Wrapper<TaskListComponent> implements OnInit, OnDestroy {

    public filteredTasks = []
    public sortByDate: boolean
    public condensedView: boolean
    public helpers = publicHelpers
    tasksLoading
    prefsLoading
    

    now_time
    /*   dragula_tasks = [] */
    subtasksCompleted = {};
    unseenCommentsByTask = {}
    overdueTasks = {}
    seenToggled = {};
    seen_toggeled_delay = 4 * 1000;
    show_new_task_input = false;
    new_task_name: string;
    _file = 'task-list.component.ts';

    event: JoiEvent;
    @ViewChild('taskNameEl') taskNameEl;
    @Input() readonly = false;
    @Input() placement
    @ViewChild('tasksEl', { static: true }) tasksEl: ElementRef;

    scrollToBottomHeight: number

    workersByEmail: { [key:string]: WFWorker } = {}
    task_labels: LabelObject = {}

    constructor() {
      super()
      this.subProp(this.store.select('tasks', 'loading'), 'tasksLoading')
      this.subProp(this.store.select('eventPreferences', 'loading'), 'prefsLoading')
      this.subCallback(this.store.select('events', 'event'), event => {
        this.event = event
        this.reset()
      })
    }

    ngOnInit() {
      this.subProp(this.store.select('events', 'labelMaps', 'task_labels'), 'task_labels')
      this.subCallback(this.store.select(this.placement === 'sidebar' ? getFilteredSidebarTasks : (this.placement === 'my_tasks' ? getFilteredMyTasks : getFilteredPageTasks)), filteredTasks => {
        this.filteredTasks = filteredTasks
        filteredTasks.forEach(({ id, commentBookmarks, comments, date }) => {
          if (date && date < new Date()) {
            this.overdueTasks[id] = true
          }
          this.unseenCommentsByTask[id] = !comments ? 0 :
            !commentBookmarks || !commentBookmarks[this.userService.uid] ? comments.length :
            comments.length - commentBookmarks[this.userService.uid]
        })
    })


    this.subCallback(this.store.select('tasks','entities'), data => {
      // this needs to go in OnInit and not in the constructor above
      this.checkIfNeedToScroll()
    })


    this.subProp(this.store.select('filters', 'toggleFilters', this.placement === 'sidebar' ? filterPageTypes.tasksSidebar : (this.placement === 'my_tasks' ? filterPageTypes.myTasks : filterPageTypes.tasks), toggleFilterTypes.sortByDate), 'sortByDate')

    this.subProp(this.store.select('filters', 'toggleFilters', this.placement === 'sidebar' ? filterPageTypes.tasksSidebar : (this.placement === 'my_tasks' ? filterPageTypes.myTasks : filterPageTypes.tasks), toggleFilterTypes.condensed), 'condensedView')

    const currentdate = new Date();
    this.now_time = currentdate.getTime();
    const that = this;
    //  const drake = this.dragula['createGroup'](this.placement + '-tasks-bag', {
    //     // mirrorContainer: this.tasksEl.nativeElement,
    //     moves: function (el, container, handle) {
    //         return handle.classList.contains('handle');
    //     },
    // })
    // this.subCallback(this.dragula.dropModel(), ({ sourceModel }) => {
    //   that.taskService.reorderTasks(sourceModel.map(x => x.id))
    // })
    // setTimeout(() => {
    //     const container = document.querySelector('.task-scrollable-' + this.placement) // this.tasksEl.nativeElement;
    //     drake.drake.on('out', (el, source) => {
    //         const bound = container.getBoundingClientRect()
    //         document.onmousemove = e => {
    //             const event = e || window.event;
    //             const mouseY = event['pageY'] // - container.getBoundingClientRect().top;
    //             if (mouseY < bound.top) {
    //                 container.scrollBy(0, -15);
    //             } else if (mouseY > (bound.bottom - 60)) { // 60 is the add task button
    //                 container.scrollBy(0, 15);
    //             }
    //         }
    //     })

    //     // detach the mouse move event when the drag ends
    //     drake.drake.on('dragend', el => {
    //         document.onmousemove = null;
    //     });
    //     drake.drake.on('over', el => {
    //         document.onmousemove = null;
    //     });
    // }, 0)
    this.subProp(this.store.select('workforce', 'workersByEmail'), 'workersByEmail')

  }
    
  toggleUnseen(task: Task) {
    this.seenToggled[task.id] = true;
    setTimeout(_=>this.seenToggled[task.id] = false, this.seen_toggeled_delay)
    task.seen[this.userService.uid] = !task.seen[this.userService.uid];
    this.taskService.updateTask(task.id, {...task}, { function: 'toggleUnseen', error: new Error })
  }

  newTaskReady() {
      this.reset(true);
      setTimeout(_ => {
        this.reset(true);
        this.taskNameEl.nativeElement.focus();
      }, 0)
  }
  reset(show_new_task_input?) {
      this.show_new_task_input = show_new_task_input;
      this.new_task_name = '';
  }

  updateSubtaskCompleted(event: Event, task: Task, subtask: Subtask) {
    event.stopPropagation()
    this.taskService.updateSubtaskCompleted(task, subtask)
  }

  async popupNewTask() {
    const task = await this.taskService.createAndSaveTask(this.new_task_name)
    const result = await this.editTask(task)
    if (result !== 'Delete') {
      this.changeTaskOrder(task.id)
      this.addScrollingPoint()
      this.checkIfNeedToScroll() // task has already been added and closed by this point
    }
  }

  async addTask(ev: Event = null) {
    if(ev) ev.stopPropagation()
    const task = await this.taskService.createAndSaveTask(this.new_task_name)
    this.addScrollingPoint()
    this.changeTaskOrder(task.id)

  }

  addScrollingPoint() {
    if (this.tasksEl && this.tasksEl.nativeElement) { // the scroll value for the sidebar container doesn't match up with the actual list height in a reasonable way, but setting it to an arbitrarily high number scrolls it to the bottom of the list.
      this.scrollToBottomHeight = this.placement === 'sidebar' ? 99999 : this.tasksEl.nativeElement.scrollHeight
    }
  }

  checkIfNeedToScroll() {
    if (this.scrollToBottomHeight) this.scrollToBottom(this.scrollToBottomHeight)
    this.scrollToBottomHeight = null
  }

  scrollToBottom(num) {
    setTimeout(_ => {
        if (!this.tasksEl || !this.tasksEl.nativeElement) return
        const scrollEl = this.placement === 'sidebar' ? document.getElementById('taskSidebarScroller') : this.tasksEl.nativeElement
        scrollEl.scrollTop = num
        console.log(`Should be scrolling by ${num}`, scrollEl) // you can remove this, it's to show what elements are being affected
    }, 0)
  }

  async changeTaskOrder(taskId: string) {
    const preferences:EventPreferenceDoc = await transformObservableToSinglePromise(this.store.select('eventPreferences', 'document'))
    if(!preferences || !preferences.createdAt) {
      const newPreferences:EventPreferenceDoc = { createdAt:new Date(), task_order:[taskId] }
      this.eventService.createEventPreferences(newPreferences, this.eventService.eventId, this.userService.uid, { file: this._file, function: 'addTask', error: new Error })
    } else {
      preferences.task_order.push(taskId)
      this.eventService.updateEventPreferences(preferences, this.eventService.eventId, this.userService.uid, { file: this._file, function: 'addTask', error: new Error })
    }
    this.newTaskReady()
  }

  async deleteSubtask(task: Task, subtask_idx: number, evt) {
      const rect = evt.target.getBoundingClientRect();
      const data: ConfirmDeleteData = { rect, title: 'Delete this subtask', dialog: this.dialog }
      
      const del = await openConfirmDeleteGetResult(data)
      if (!del) return
      const id = task.subtasks[subtask_idx];
      const update_obj:Partial<Task> = {
        id:task.id,
        subtasksCompleted: task.subtasks_obj[id].completed ? task.subtasksCompleted - 1 : task.subtasksCompleted,
        subtasks_obj:{...task.subtasks_obj},
        subtasks:task.subtasks.filter(stid=>stid!==id)
      }
      delete update_obj.subtasks_obj[id];
      this.taskService.updateTask(task.id, update_obj)

  }

  openTaskDialog(task, evt) {
      this.reset();
      if (evt.target.nodeName === 'TEXTAREA'
          || evt.target.classList.contains('no-popup')
          || evt.target.classList.contains('mat-checkbox-inner-container')
      ) return;
      this.editTask(task)
  }

  async editTask(task: Task){
    const data: ManageTaskData = {
      task,
      readOnly: this.readonly,
      limited: this.placement === 'my_tasks'
    }
    this.store.dispatch(tasksActions.taskInFocus(task.id))
    const result = await openDialogGetResult<ManageTaskReturnType>(this.dialog, ManageTaskComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.store.dispatch(tasksActions.taskInFocus(null))
    return result
  }


  trackByIdx(index, item) {
      return index;
  }

  trackById(index, item) {
      return item.id;
  }

  trackByFn(index, item) {
      return index;
  }

  trackByNone(index, item) {
      return true;
  }

  ngOnDestroy() {
    //this.dragula.destroy(this.placement + '-tasks-bag')
  }
}
